<template>
  <div>
    <!-- results of detection written to "javaresult" -->
    <!-- <div id="javaresult"></div> -->
    <div class="device-list">
      <div class="device-list__rows-wrapper">
        <ul class="device-list__row device-list__row--title">
          <li
            class="show-pointer"
            @click="changeSortOrder('devDescription')"
          >
            {{ $t("messages.deviceList.deviceDescription") }}
          </li>
          <li
            v-if="computedGetPermissions.ngwi"
            title="Web Interface"
          >
            {{ $i18n.whitelabel.appTitle }}
          </li>
          <li
            v-if="computedGetPermissions.jTurf"
            title="the Java App inteface"
          >
            {{ $t("messages.deviceList.cycleManager") }}
          </li>
          <li
            v-if="computedGetPermissions.ngwi === false"
            title="emulated Controller interface"
          >
            {{ $t("messages.deviceList.virtualController") }}
          </li>
        </ul>
      </div>
      <div
        v-if="!dataReceived"
        class="device-list__spinner"
      />
      <div
        v-if="dataReceived && !devicesSorted.length"
        class="device-list__no-controllers"
      >
        no controllers assigned
      </div>
      <transition-group
        v-else
        class="device-list__rows-wrapper device-list__rows-wrapper--border"
        name="flip-list"
        tag="div"
      >
        <div
          v-for="device in devicesSorted"
          :key="device._id"
          class="device-list__row-wrapper"
          :class="{'device-list__row-wrapper--busy': !device._icons.status.buttonState}"
        >
          <ul class="device-list__row device-list__row__main">
            <li
              class="device-list__title show-pointer"
              @click="toggleDeviceDescription"
            >
              <span>{{ `${device._id + 1}. ${device._displayName}` }}</span>
              <span class="flipper" />
            </li>
            <li
              v-if="computedGetPermissions.ngwi"
              :class="{ 'show-pointer': device._icons.ngwi.show }"
              @click="openNGWI( device.ctrlid, device.devDescription, device.typename, device.active, device.newstate, device.userid)"
            >
              <div
                v-if="device._icons.ngwi.show"
                class="device-list__icon"
                :title="$tc('messages.deviceList.active', (device.active === 'Active' ? 1 : 0))"
                :class="{ active: device._icons.ngwi.buttonState }"
                :style="{backgroundColor: device._icons.ngwi.bgColor}"
              >
                <img
                  alt="Web Interface"
                  :src="device._icons.ngwi.image"
                >
              </div>
            </li>
            <li
              v-if="computedGetPermissions.jTurf"
              :class="{ 'show-pointer': device._icons.cycle.buttonState && computedGetPermissions.jTurf }"
              @click="openJTurf( device.ctrlid, device.typename, device.active, device.newstate)"
            >
              <div
                class="device-list__icon"
                :title="computedGetPermissions.jTurf ? $tc('messages.deviceList.active', (device.active === 'Active' ? 1 : 0)) : $t('messages.deviceList.accessDenied')"
                :class="{ active: device._icons.cycle.buttonState && computedGetPermissions.jTurf !== false }"
                :style="{backgroundColor: device._icons.cycle.bgColor}"
              >
                <img
                  alt="Cycle Manager"
                  :src="device._icons.cycle.image"
                >
              </div>
            </li>
            <li
              v-if="computedGetPermissions.ngwi === false"
              class="virtual-control"
              :class="{ 'show-pointer': device._icons.virtual.show }"
              @click="openVirtual( device.ctrlid, device.typename, device.active, device.newstate, device._icons.virtual.show, device.userid, device.devDescription)"
            >
              <div
                v-if="device._icons.virtual.show"
                class="device-list__icon device-list__icon--prefer-height"
                :title="$tc('messages.deviceList.active', (device.active === 'Active' ? 1 : 0))"
                :class="{ active: device._icons.virtual.buttonState }"
                :style="{backgroundColor: device._icons.virtual.bgColor}"
              >
                <img
                  alt="Virtual Control"
                  :src="device._icons.virtual.image"
                >
              </div>
            </li>
          </ul>
          <div
            class="device-list__row device-list__row--small device-list__row__secondary"
            @click="toggleDeviceDescription"
          >
            <p
              class="flipper flipper--back"
              @click="toggleDeviceDescription"
            />
            <div class="device-list__row__secondary__content">
              <ul>
                <li>
                  <p><strong>{{ $t("messages.deviceList.status") }}:&nbsp;</strong></p>
                  <p>{{ $tc("messages.deviceList.active", device._icons.status.buttonState) }}</p>
                </li>
                <li>
                  <p><strong>{{ $t("messages.deviceList.type") }}:&nbsp;</strong></p>
                  <p>{{ device.typename }}</p>
                </li>
                <li>
                  <p><strong>{{ $t("messages.deviceList.state") }}:&nbsp;</strong></p>
                  <p>{{ $tc('messages.deviceList.active', (device.active === 'Active' ? 1 : 0)) }}</p>
                </li>
                <li>
                  <p><strong>{{ $t("messages.deviceList.controllerID") }}:&nbsp;</strong></p>
                  <p>{{ device.ctrlid }}</p>
                </li>
              </ul>
              <ul>
                <li>
                  <p><strong>{{ $t("messages.deviceList.online") }}:&nbsp;</strong></p>
                  <p>{{ device.online }}</p>
                </li>
                <li>
                  <p><strong>{{ $t("messages.deviceList.upSince") }}:&nbsp;</strong></p>
                  <p>{{ device.newDate }}</p>
                </li>
                <li>
                  <p><strong>{{ $t("messages.deviceList.IPAddress") }}:&nbsp;</strong></p>
                  <p>{{ device.ipaddr }}:{{ device.octrlgport }}</p>
                </li>
              </ul>
              <ul>
                <li>
                  <p><strong>{{ $t("messages.deviceList.dBm") }}:&nbsp;</strong></p>
                  <p>{{ device.dBm }}</p>
                </li>
                <li>
                  <p><strong>{{ $t("messages.deviceList.IMEI/MAC") }}:&nbsp;</strong></p>
                  <p>{{ device.imeiMac }}</p>
                </li>
                <li>
                  <p><strong>{{ $t("messages.deviceList.userID") }}:&nbsp;</strong></p>
                  <p>{{ device.userid }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </transition-group>
      <transition-group
        class="device-list__rows-wrapper device-list__rows-wrapper--border"
        name="flip-list"
        tag="div"
      >
        <div
          v-for="interfaceRecord in intefacesSorted"
          :key="interfaceRecord._id"
          class="device-list__row-wrapper "
          :class="isEven(devicesSorted.length) ? 'interface-odd-row-wrapper' : 'interface-even-row-wrapper'"
        > 
          <!-- {{ isEven(devicesSorted.length) }} -->
          <ul class="device-list__row device-list__row__main">
            <li
              class="device-list__title show-pointer"
              @click="toggleDeviceDescription"
            >
              <span>{{ `${interfaceRecord._id + 1}. ${interfaceRecord._displayName}` }}</span>
              <span class="flipper" />
            </li>
            <li
              v-if="computedGetPermissions.ngwi"
              :class="{ 'show-pointer': interfaceRecord._icons.inter.show }"
              class="show-pointer"
              @click="openInterface( interfaceRecord.ctrlid , interfaceRecord.sw_version, interfaceRecord._icons.inter.buttonState )"
            >
              <div
                class="device-list__icon"
                :class="{ active: interfaceRecord._icons.inter.buttonState }"
                :style="{backgroundColor: interfaceRecord._icons.inter.bgColor}"
                style="height: 51.5px"
              >
                <img
                  alt="Web Interface"
                  :src="interfaceRecord._icons.inter.image"
                >
              </div>
              <span class="flipper" />
            </li>
            <li
              class="show-pointer"
            >
              <span class="flipper" />
            </li>
          </ul>
          <div
            class="device-list__row device-list__row--small device-list__row__secondary"
            @click="toggleDeviceDescription"
          >
            <p
              class="flipper flipper--back"
              @click="toggleDeviceDescription"
            />
            <div class="device-list__row__secondary__content">
              <ul>
                <!-- <li>
                  <p><strong>{{ $t("messages.deviceList.state") }}:&nbsp;</strong></p>
                  <p>{{ $tc('messages.deviceList.active', (device.active === 'Active' ? 1 : 0)) }}</p>
                </li> -->
                <li>
                  <p><strong>{{ $t("messages.deviceList.controllerID") }}:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.ctrlid }}</p>
                </li>
                <li>
                  <p><strong>Software Version::&nbsp;</strong></p>
                  <p>{{ interfaceRecord.sw_version }}</p>
                </li>
                <li>
                  <p><strong>Hardware Version:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.hw_version }}</p>
                </li>                          
              </ul>
              <ul>
                <li>
                  <p><strong>{{ $t("messages.deviceList.online") }}:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.online }}</p>
                </li>
                <li>
                  <p><strong> CU Software Version:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.cu_sw_version }}</p>
                </li> 
                <li>
                  <p><strong>CU Hardware Version:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.cu_hw_version }}</p>
                </li> 
              </ul>
              <ul>
                <li>
                  <p><strong>{{ $t("messages.deviceList.IMEI/MAC") }}:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.mac_address }}</p>
                </li>
                <li>
                  <p><strong>Updated:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.updated }}</p>
                </li>
                <li>
                  <p><strong>Created:&nbsp;</strong></p>
                  <p>{{ interfaceRecord.created }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
/* Mixins */
import {SocketHandler, LifeCycle, MicroService} from '@/assets/javascript/mixins/Mixins'
/* ------ */
import * as iconsLib from '@/assets/javascript/Icons-lib'; // eslint-disable-line

// import Logout from "@/components/Logout.vue";
// import dateFormat from 'dateformat';
import $ from 'jquery'

var JavaStatus = -9999
// If the verifyTags input argument is not specified or is null, then PluginDetect assumes
// a default value. Only the very first Java PluginDetect command that is executed
// would need to have the verifyTags input argument, if at all. You do not have to specify
// this input arg in any subsequent Java PluginDetect commands.
// verifyTags = [3,3,3];
const verifyTags = [3, 3, 3]

export default {
  name: 'DeviceList',
  mixins: [SocketHandler, LifeCycle, MicroService],
  props: {
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      dataReceived: false,
      interfaceexists:false,
      deviceListData: [],
      interfaceListData: [],
      deviceListSortOrder: '',
      devices: [],
      interfaces: [],
      showJTurfLoadingModal: false,
      showAboutModal: false,
      user: '',
      deviceListColDef: [],
      modalData: '',
      expandedRowList: [],
      state: [
        'None',
        'Created',
        'Active',
        'Demo',
        'Passive',
        'Retired'
      ],
      ongoingTouches: [],
      idleTimeout: '',
      pollTimer: null
    }
  },
  computed: {
    computedGetPermissions() {
      const access = this.store.getData('user.access')
      Object.assign(access, {
        jTurf: this.$i18n.whitelabel.showCycleManager && access.jTurf
      })
      return access
    },
    intefacesSorted() {
      return this.interfaces
    },
    devicesSorted() {
      // no need to sort if it's empty, then just return it
      if(this.devices.length === 0) {
        return this.devices
      }

      var tempArray = this.devices.slice(0) // create clone of array or state will be inherited
      var hasChanged = false

      if(this.deviceListSortOrder === 'devDescription') {
        tempArray.sort(function(a, b) {
          var stringA = a.devDescription.toLowerCase()
          var stringB = b.devDescription.toLowerCase()

          if(stringA < stringB) { // sort string ascending
            return-1
          }
          if(stringA > stringB) {
            return 1
          }

          return 0 // default return value (no sorting)
        })

        hasChanged = true
      }

      return(!hasChanged) ? this.devices : tempArray
    }
  },
  watch: {
    PageMessage(Message) {
      if(Message.target === 'toggle-devicelist-layout')
        this.toggleDevicelistType()
    },
    SocketMessage(Message) {
      var cleanedMessage = JSON.stringify(Message).replace('"{', '{').replace('}"', '}').replace(/\\/g, '')  // strip out udp Packet generated "'s around inner data - jimm 08.mar.2021
      Message = JSON.parse(cleanedMessage)
      // mini parser for reloading devicelist via UDP message
      if(Message.data.type == 'devicelist') {
        let udpCtrlId = parseInt(Message.data.data.id, 10)
        let udpSnrId = Message.data.data.snr
        if( this.devicesSorted.find( record => record.ctrlid === udpCtrlId ) ) {
          this.getDeviceList()
        }
        if( this.intefacesSorted.find( record => record.snr === udpSnrId ) ) {
          this.getDeviceList()
        }
      }

      if(Message.data.category !== undefined) {
        switch(Message.data.category) {
        case'data':
          switch(Message.data.command) {
          case'get':
            switch(Message.data.data.type) {
            case'dataset':
              break
            default:
              break
            }
            break
          default:
            break
          }
          break
        case'server':
          switch(Message.data.command) {
          case'button':
            if(Message.data.data && Message.data.data.type === 'JTurf' && Message.data.data.id) {
              var webStartURL = `${location.protocol}//${location.hostname}/cgi-bin/JTStart.jnlp`
              if(Message.data.data && Message.data.data.id) {
                webStartURL += `?ID=${Message.data.data.id}`
              }

              window.open(webStartURL)
            }
            break
          default:
            break
          }
          break
        default:
          break
        }
      }

      // console.log('store user.access: ', JSON.stringify(this.store.getData('user.access'), null, 4))
      // console.log('store user.perm: ', this.store.getData('user.perm'))
      // console.log('store user.permid: ', this.store.getData('user.permid'))
      // console.log('store user.permission: ', JSON.stringify(this.store.getData('user.permissions'), null, 4))
    },
    showJTurfLoadingModal(val) {
      if(val) {
        this.$emit('SetPageMessage', {
          target: 'ShowModal',
          modalData: {
            component: 'DialogueModal',
            data: {
              title: this.$t('messages.sharedTexts.status.pleaseStandBy'),
              text: this.$t("messages.deviceList.loadingCycleManager"),
              prefix: 'devicelist-open-dialogue-modal-',
              options: []
            }
          }
        })
      } else {
        this.$emit('SetPageMessage', {target: 'CloseModal', component: 'DialogueModal'})
      }
    },

    interfaceListData(data) {
      this.interfaces = data.rowData

      this.interfaces.forEach(interfaceRecord => {
        interfaceRecord._icons = {}
        interfaceRecord._displayName = interfaceRecord.hostname
        interfaceRecord.ctrlid = interfaceRecord.snr
        interfaceRecord._icons.inter = {
          image: require('@graphics/NextGenWebInterfaceMK3.png'),
          bgColor: (interfaceRecord.online) ? 'rgb(42,61,75)' : 'red',
          buttonState: (interfaceRecord.online),

          // buttonState: !(device.active === 'Busy' || (device.newstate !== 'Active' && device.newstate !== 'Demo')),
          // show: (!(device.typename.indexOf('WS') === device.typename.length - 2))
        }
      })
    },
    /** _name for added data */
    deviceListData(data) {
      this.devices = data.rowData

      this.devices.forEach(device => {
        device._icons = {}

        device._displayName = device.devDescription

        device._icons.status = {
          image: require('@graphics/ActiveController.png'),
          bgColor: (device.active === 'Active') ? 'rgb(42,61,75)' : 'red',
          buttonState: (device.active === 'Active')
        }
        device._icons.ngwi = {
          image: require('@graphics/NextGenWebInterface.png'),
          bgColor: 'rgb(42, 61, 75)',
          buttonState: !(device.active === 'Busy' || (device.newstate !== 'Active' && device.newstate !== 'Demo')),
          show: (!(device.typename.indexOf('WS') === device.typename.length - 2))
        }
        // show: (device.typename.charAt(device.typename.length - 2) !== 'W' || device.typename.charAt(device.typename.length - 1) !== 'S')

        device._icons.cycle = {
          image: iconsLib.getCycleIcon(device.typename),
          bgColor: 'rgb(42, 61, 75)',
          buttonState: !(device.active === 'Busy' || (device.newstate !== 'Active' && device.newstate !== 'Demo'))
        }

        let icon = ''
        if(device.typename.toLowerCase().slice(-2) !== 'ws') {
          icon = iconsLib.getDeviceGraphic(this, 'icon', device.typename)
        }

        device._icons.virtual = {
          image: icon,
          bgColor: 'transparent',
          buttonState: !(device.active === 'Busy' || (device.newstate !== 'Active' && device.newstate !== 'Demo')),
          show: (!(device.typename.indexOf('WS') === device.typename.length - 2))
        }

        var dateNow = new Date()
        if(device.uptime !== '' && device.uptime !== undefined) {
          device.newDate = new Date(dateNow.getTime() - (device.uptime * 1000))
          // above alone gives: Thu Aug 31 2017 15:36:34 GMT +0200 (Romance Daylight Time)
          // below gives: Thu Aug 31 2017 15:36:34 UTC +0200
          // device.newDate = dateFormat(device.newDate, 'ddd mmm dS yyyy HH:MM:ss Z');
        } else {
          device.newDate = this.$t("messages.deviceList.notUp")
        }

        if(device.rssi !== '' && device.rssi !== undefined && Number(device.rssi) > 0) {
          device.dBm = Math.round(((-1) * (109 - 2.0357 * (device.rssi - 2))))
        } else {
          device.dBm = this.$t("messages.deviceList.noSignal")
        }
      })
    }
  },
  mounted() {
    // clearInterval(this.pollTimer)
    // set a simple timer to logout after ten minutes of inactivity in the deviceList - jip 2018.03.28
    const urlParams = new URLSearchParams(window.location.search)
    //const authToken = urlParams.get('token') ? urlParams.get('token') : undefined
    const authToken = this.$route.query.token
    //const ctrlid = urlParams.get('ctrlid') ? urlParams.get('ctrlid') : undefined
    const ctrlid = this.$route.query.ctrlid
    if((authToken !== undefined) && (ctrlid !== undefined)) {
      this.getdevice(authToken, ctrlid)
    } else if(authToken !== undefined) {
      this.getDeviceList(authToken)
    } else {
      setTimeout(this.getDeviceList, 1000) 
    

    // this.pollTimer = setInterval(this.getDeviceList, 10E3)

      if( this.store.getData('user.permid') === "1" ) { // tucadm
        this.$emit('SetPageMessage', {
          target: 'FooterButtons',
          data: [{
            label: 'Admin',
            route: '/admin',
            className: 'ButtonRight'
          }]
        })
      } 
    } 
  },
  destroyed() {
    clearInterval(this.pollTimer)
  },
  methods: {
    async getDeviceList() {
      const response = await this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getdevicelistnew`
      })

      if(!response.data.getdevicelistnew) {
        return null
      }
      
      this.interfaceListData = {
        user: this.loginUser,
        rowData: this.parseInterfaceListData(response.data.getdevicelistnew[0].interfacelist, response.data.getdevicelistnew[0].devicelist.length)
      }

      this.deviceListData = {
        user: this.loginUser,
        rowData: this.parseDeviceListData(response.data.getdevicelistnew[0].devicelist)
      }
      this.dataReceived = true
      if(response.data.getdevicelistnew[0].interfacelist.length > 0) {
        this.interfaceexists = true
      }
    },

    getdevice(authToken, ctrlid) {
      console.log(authToken)
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/authenticated/function/getdevicedata?auth_token=${authToken}&ctrlid=${ctrlid}`
      })
      .then((response) => {
        const ctrlid = response.data.getdevicedata.result.ctrlid
        const devDescription = response.data.getdevicedata.result.description
        const typename = response.data.getdevicedata.result.typename
        const active = response.data.getdevicedata.result.active
        const userid = response.data.getdevicedata.result.userid
        const newstate = response.data.getdevicedata.result.newstate
        this.openNGWI(ctrlid, devDescription, typename, active, newstate, userid)
      }).catch(this.redirect)
    },

    parseDeviceListData(data) {
      var rowDataTemp = []
      for(var i = 0; i < data.length; i++) {
        if(data[i].typename) {
          var strTmp
          if(data[i].info && data[i].info.length > 0) {
            strTmp = data[i].info.substring(1)
            var endIdx = strTmp.search('#')
            strTmp = strTmp.substring(0, endIdx)
          } else {
            strTmp = this.$t("messages.deviceList.notAvailable")
          }
          rowDataTemp.push({
            _id: i,
            typename: data[i].typename.toUpperCase(),
            devDescription: data[i].description,
            ctrlid: data[i].ctrlid,
            online: data[i].online,
            active: (data[i].active > 0) ? 'Busy' : 'Active',
            newstate: this.state[data[i].newstate],
            userid: data[i].userid,
            select: 'select button ' + i,
            jTurf: 'jTurf button ' + i,
            jsControl: 'jsControl button ' + i,
            ipaddr: data[i].ipaddr,
            octrlgport: data[i].octrlgport,
            rssi: data[i].rssi,
            uptime: data[i].uptime,
            imeiMac: strTmp
          })
        }
      }
      return rowDataTemp
    },
    parseInterfaceListData(data, deviceLength) {
      var rowDataTemp = []

      for(var i = 0; i < data.length; i++) {
        if(data[i].snr.length > 0) {
          var strTmp
          if(data[i].info && data[i].info.length > 0) {
            strTmp = data[i].info.substring(1)
            var endIdx = strTmp.search('#')
            strTmp = strTmp.substring(0, endIdx)
          } else {
            strTmp = this.$t("messages.deviceList.notAvailable")
          }
          rowDataTemp.push({
            _id: i + deviceLength,
            id: data[i].id,
            snr: data[i].snr,
            online: data[i].online,
            hostname: data[i].hostname,
            mac_address: data[i].mac_address,       // 02:33:05:68:3d:02,
            hw_version: data[i].hw_version,         // 1,
            sw_version: data[i].sw_version,         // 106,
            cu_id: data[i].cu_id,                   // 37578757,
            cu_hw_version: data[i].cu_hw_version,  // 2,
            cu_sw_version: data[i].cu_sw_version,  // 102,
            updated: data[i].updated,               // 2021-01-26T15:01:24.913132+01:00,
            created: data[i].created,              // 2021-01-26T130510.748574+0100
          })
        }
      }
      return rowDataTemp
    },
    isEven(value){
      if (value%2 == 0) {
        return true
      } else {
        return false
      }
    },
    timedOut() {
      this.$router.push('/logout')
    },
    changeSortOrder(sortByString) {
      if(sortByString === this.deviceListSortOrder) {
        this.deviceListSortOrder = ''
      } else {
        this.deviceListSortOrder = sortByString
      }
    },
    toggleDeviceDescription(e) {
      $(e.target).closest('.device-list__row-wrapper').toggleClass('flip')
    },
    openJTurf(ctrlid, typename, active, newstate) {
      if(!this.computedGetPermissions.jTurf) {
        return
      }

      if(active !== 'Busy' && newstate !== 'Passive') {
        this.showJTurfLoadingModal = true
        setTimeout(() => {
          this.showJTurfLoadingModal = false
        }, 10000)

        this.SocketMessageSend({
          category: 'server',
          command: 'button',
          data: {
            name: 'JTurf',
            type: 'device',
            item: ctrlid,
            typename: typename.toLowerCase(),
            controllerType: typename
          }
        })
        /*
          this.serverRequest("server", "button", {
            "name": "JTurf",
            "type": "device",
            "item": ctrlid,
            "typename": typename.toLowerCase(),
            "controllerType": typename
          });    */
      }
    },
    openInterface(ctrlid, sw ,buttonState) {
      // Simulate an HTTP redirect/mouse click:
      // window.location.replace("https://demo01.src.dk/?id=" + ctrlid)

      // open window in new tab
      if(buttonState) {
        window.open("https://remote.mysrc.online/v" + sw + "/?id=" + ctrlid, "_blank")
      }
    },
    openNGWI(ctrlid, devDescription, typename, active, newstate, userid) {
      if(active !== 'Busy' && newstate !== 'Passive' && (!(typename.indexOf('WS') === typename.length - 2))) {
        var type = typename

        this.SocketMessageSend({
          category: 'server',
          command: 'select',
          data: {
            type: 'device',
            item: ctrlid,
            typename: type.toLowerCase(),
            controllerType: typename
          }
        })

        this.$emit('SetPageMessage', {
          target: 'SetDevice',
          data: {
            typename: type,
            controllerType: typename,
            ctrlid: ctrlid,
            devDescription: devDescription,
            active: active,
            userid: userid
          }
        })

        clearTimeout(this.idleTimeout)
        window.location.href.replace(window.location.search, '')   
        this.setMicroServiceParameters(ctrlid, typename)
        this.$router.push('/home')
      }
    },
    
    openVirtual(ctrlid, typename, active, newstate, show, userid, devDescription) {
      var type = typename

      if(active !== 'Busy' && newstate !== 'Passive' && show !== false) {
        // if(active !== "Busy" && newstate !== "Passive") {
        window.deviceSelected = ctrlid

        let data = {
          typename: type,
          controllerType: typename,
          ctrlid: ctrlid,
          devDescription: devDescription,
          active: active,
          userid: userid
        }

        this.SocketMessageSend({
          category: 'server',
          command: 'select',
          data: {
            type: 'device',
            item: ctrlid,
            typename: type.toLowerCase(),
            controllerType: typename
          }
        })
        this.$emit('SetPageMessage', {
          target: 'SetDevice',
          data
        })

        clearTimeout(this.idleTimeout)

         this.$emit('SetPageMessage', {
          target: 'ShowModal',
          modalData: {
            component: 'JSControl',
            data
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
  ol, ul, dl {
      margin-top: 0;
      margin-bottom: 0;
  }
.device-list {
  $iconSize: 25px;

  font-size: 11px;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 60px; // chrome mobile has issues showing the last item, this is a patch not a solution

  &__spinner {
    @include spinner('after', 100px, 5px, $color-grey-dark);
    text-align: center;
    margin: 50px;
  }

  .flip-list-enter-active, .flip-list-leave-active {
    transition: opacity .5s;
  }
  .flip-list-enter, .flip-list-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .show-pointer {
    cursor: pointer;
  }

  &__no-controllers {
    text-align: center;
    padding: 50px;
    font-size: 28px;
    text-transform: capitalize;
    line-height: 33px;
  }

  &__rows-wrapper {
    display: block;
    margin: 0;
  }
  &__row-wrapper {
    border: 0;
    box-shadow: none;
    background-color: lighten($color-grey, 10);

    &:nth-child(odd) {
      background: $color-white;
    }

    &--busy {
      opacity: 0.3;
    }
  }
  
  .interface-even-row-wrapper {
    border: 0;
    box-shadow: none;
    background-color: lighten($color-grey, 10);

    &:nth-child(even) {
      background: $color-white;
    }

    &--busy {
      opacity: 0.3;
    }
  }

   .interface-odd-row-wrapper {
    border: 0;
    box-shadow: none;
    background-color: lighten($color-grey, 10);

    &:nth-child(odd) {
      background: $color-white;
    }

    &--busy {
      opacity: 0.3;
    }
  }

  &__row {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    text-align: center;
    border-bottom: 1px solid $color-grey;

    &--title {
      background-color: lighten($color-grey, 10) !important;
      font-family: $font-primary-semibold;

      li {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 19px !important;
      }
      &:not(:last-child) {
        border-bottom: 1px dotted $color-grey;
      }
    }

    li {
      padding: 5px;
      margin: 0px;

      &:first-child {
        display: flex;
        align-items: center;
        padding-left: 20px;
        min-width: 35px;
      }

      &:not(:last-child) {
        border-right: 1px dotted $color-grey;
      }
    }

    &__secondary {
      position: relative;
      display: none;
      text-align: left;
      background-color: inherit;
      border-bottom: 1px dotted $color-grey;

      .flip & {
        display: block;
      }

      &__content {
        display: grid;
        grid-template-columns: repeat(3, 33%);
        padding: 10px !important;

        ul {
          text-align: center;
          overflow-wrap: break-word;
          &:not(:last-child) {
            border-right: 1px dotted $color-grey;
          }

          li {
            display: block !important;
            padding: 10px !important;
            border: 0 !important;
          }
        }
      }
    }
  }
  &__icon {
    width: 100%;
    height: 100%;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    img {
      display: inline-block;
      width: $iconSize * 2;
    }

    &--prefer-height img {
      width: inherit !important;
    }

    &:not(.active) {
      opacity: 0.45;
      // filter: saturate(50%);
    }
  }
}

@media screen and (min-width: $bp-tablet) {
  .device-list {
    $iconSize: 50px;
    // border: 1px solid $color-grey-dark;
    &__icon {
      width: $iconSize * 2;
      display: inline-block;
      img {
        width: $iconSize;
      }
    }
    &__row {
      font-size: 13px;
      &--title {
        font-size: 15px;
      }
      &__secondary {
        &__content {
          ul {
            text-align: left !important;
            li {
              * {
                display: inline;
              }
            }
          }
        }
      }
    }
  }
}
</style>
